import React, {Component} from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addCount } from './redux/actions';
import store from './redux/store';

import FrontPage from './containers/FrontPage';
import MenuPage from './containers/MenuPage';
import ContentPage from './containers/ContentPage';
import ContactPage from './containers/ContactPage';
import BlogPage from './containers/BlogPage';
import PostPage from './containers/PostPage';
import Header from './containers/Header/Header';
import Footer from './containers/Footer/Footer';
import CookieNotice from './containers/CookieNotice/CookieNotice';
import Cart from './components/Shopify/Cart';
import ModalNewsLetter from './components/NewsLetter/ModalNewsLetter';

import { shopClient } from './api/shopifyAPI'

import './App.css';

class App extends Component {
  constructor() {
    super();

    this.state = {
      isCartOpen: false,
      checkout: { lineItems: [] }
    };

    this.handleCartToggle = this.handleCartToggle.bind(this);
    this.addVariantToCart = this.addVariantToCart.bind(this);
    this.updateQuantityInCart = this.updateQuantityInCart.bind(this);
    this.removeLineItemInCart = this.removeLineItemInCart.bind(this);
  }

  componentWillMount() {
    shopClient.createCart({}).then((res) => {
      this.setState({
        checkout: res,
      });
    });
  }

  addVariantToCart(variant, quantity){
    this.setState({
      isCartOpen: true,
    });

    const lineItemsToAdd = {variant, quantity: parseInt(quantity, 10)}

    return this.state.checkout.createLineItemsFromVariants(lineItemsToAdd).then(res => {
      this.setState({
        checkout: res,
      });
    });
  }

  updateQuantityInCart(lineItemId, quantity) {
    return this.state.checkout.updateLineItem(lineItemId, quantity).then(res => {
      this.setState({
        checkout: res,
      });
    });
  }

  removeLineItemInCart(lineItemId) {
    return this.state.checkout.removeLineItem([lineItemId]).then(res => {
      this.setState({
        checkout: res,
      });
    });
  }

  handleCartToggle() {
    if(this.state.isCartOpen) {
      this.setState({
        isCartOpen: false
      })
    }
    else {
      this.setState({
        isCartOpen: true
      })
    }
  }

  // Called when component is updated by clicking a link, for example.
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.onRouteChanged();
    }
  }

  componentDidMount() {
    // Log initial entry as if route changed
    this.onRouteChanged();
  }

  // Increment page change count
  onRouteChanged() {
    store.dispatch(addCount());
  }

  render() {
    return(
      <div className="app">
        <Helmet
          titleTemplate="%s – Farang"
          meta={[
            {"property": "og:url", "content": window.location.href},
            {"property": "og:type", "content": "website"},
          ]}
        />
        <Cart
          checkout={this.state.checkout}
          isCartOpen={this.state.isCartOpen}
          handleCartToggle={this.handleCartToggle}
          updateQuantityInCart={this.updateQuantityInCart}
          removeLineItemInCart={this.removeLineItemInCart}
        />
        <Route path="/:slug?" component={Header} />
          <Switch>
            <Route exact path="/" component={FrontPage} />
            <Route path="/menu/:slug/:subslug?" component={MenuPage} />
            <Route path="/contact" component={ContactPage} />
            <Route path="/blog/:slug" component={PostPage} />
            <Route path="/blog" component={BlogPage} />
            <Route path="/:slug" component={(props) => <ContentPage {...props} addVariantToCart={this.addVariantToCart}/>} />
          </Switch>
        <Footer/>
        <CookieNotice/>
        <ModalNewsLetter />
      </div>
    )
  }
}

App.propTypes = {
  location: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
}

const mapStateToProps = state => {
  return {
    count: state.count,
  }
};

const mapDispatchToProps = {
  addCount,
};

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js